
export const baseUrl = (process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000').replace(/\/+$/, '');

export const apiEndpoints = {
    // BASIC Login/Logout Routes
    loginApi: `${baseUrl}/api/token/login/`,
    refreshTokenApi: `${baseUrl}/api/token/refresh/` ,
    verifyTokenApi : `${baseUrl}/api/status/`,
    profile_update: `${baseUrl}/api/profile/`,
    profile_image: `${baseUrl}/api/profile/image/`,
    logoutApi: `${baseUrl}/api/logout/`,
    sidebar_layout_me: `${baseUrl}/api/sidebar-layout/me/`,
    super_admin_sidebar_layouts: `${baseUrl}/api/super-admin/sidebar-layouts/`,
    super_admin_role_api_permissions: `${baseUrl}/api/super-admin/role-api-permissions/`,
    password_reset_request_code: `${baseUrl}/api/auth/password-reset/request-code/`,
    password_reset_verify_code: `${baseUrl}/api/auth/password-reset/verify-code/`,
    password_reset_confirm: `${baseUrl}/api/auth/password-reset/confirm/`,
    change_password: `${baseUrl}/api/auth/change-password/`,


    // ADD , EDIT & DELETE Student Operations url's
    add_student : `${baseUrl}/api/students/`,
    parent_lookup: `${baseUrl}/api/parents/lookup/`,
    parent_my_children: `${baseUrl}/api/parent/my-children/`,
    students_bulk_template: `${baseUrl}/api/students/bulk-import/template/`,
    students_bulk_import: `${baseUrl}/api/students/bulk-import/`,
    edit_student: `${baseUrl}/api/update/students/`,
    fetch_myschool_studs: `${baseUrl}/api/fetch-myschool-students/`,
    student_complaints_by_id: `${baseUrl}/api/fetch/complaint/student/`,
    school_admin_student_progress_reports: `${baseUrl}/api/school-admin/student-progress-reports/`,
    student_promotion_context: `${baseUrl}/api/school/student-promotion/context/`,
    student_promotion_preview: `${baseUrl}/api/school/student-promotion/preview/`,
    student_promotion_confirm: `${baseUrl}/api/school/student-promotion/confirm/`,
    student_promotion_batches: `${baseUrl}/api/school/student-promotion/batches/`,
    student_promotion_year_placements: `${baseUrl}/api/school/student-promotion/year-placements/`,
    student_promotion_revert: `${baseUrl}/api/school/student-promotion/revert/`,
    alumni_academic_years: `${baseUrl}/api/school/alumni/years/`,
    alumni_list: `${baseUrl}/api/school/alumni/`,
    student_academic_year_profile: `${baseUrl}/api/school/student-academic-year-profile/`,

    // USERS Related Stuff
    user_registrations : `${baseUrl}/api/register/`,
    super_admin_register : `${baseUrl}/api/super-admin/register/`,
    view_all_users : `${baseUrl}/api/view-all-users/`,
    fetch_school_owners_by_email : `${baseUrl}/api/get-school-owners-by-email/?email=`,
    view_all_thrillion_staffs : `${baseUrl}/api/view-all-thrillion-staff/`,
    update_thrillion_staffs : `${baseUrl}/api/update-thrillion-staff/`,
    update_school_admin_status : `${baseUrl}/api/update-school-admin-status/`,
    delete_thrillion_staffs : `${baseUrl}/api/delete-thrillion-staff/`,
    fetch_all_school_head_info : `${baseUrl}/api/view-all-school-admins/`,
    view_all_onboarded_schools_info : `${baseUrl}/api/schools/`,
    school_plan_catalog : `${baseUrl}/api/schools/plan-catalog/`,
    plans : `${baseUrl}/api/plans/`,
    super_admin_dashboard_stats : `${baseUrl}/api/super-admin/dashboard-stats/`,
    super_admin_vendor_organizations : `${baseUrl}/api/super-admin/vendor-organizations/`,
    super_admin_vendor_organization : (organizationId) =>
        `${baseUrl}/api/super-admin/vendor-organizations/${organizationId}/`,
    vendor_dashboard : `${baseUrl}/api/vendor/dashboard/`,
    vendor_staff : `${baseUrl}/api/vendor/staff/`,
    vendor_staff_detail : (staffId) => `${baseUrl}/api/vendor/staff/${staffId}/`,
    super_admin_website_visitor_stats : `${baseUrl}/api/super-admin/website-visitor-stats/`,
    demo_requests_list: `${baseUrl}/api/demo-requests/`,
    demo_requests_detail: (id) => `${baseUrl}/api/demo-requests/${id}/`,
    demo_requests_schedule: (id) => `${baseUrl}/api/demo-requests/${id}/schedule/`,
    demo_requests_log: (id) => `${baseUrl}/api/demo-requests/${id}/log/`,
    sales_prospect_schools: `${baseUrl}/api/sales-prospect-schools/`,
    sales_prospect_schools_filter_options: `${baseUrl}/api/sales-prospect-schools/filter-options/`,
    sales_prospect_schools_scrape: `${baseUrl}/api/sales-prospect-schools/scrape/`,
    sales_prospect_schools_bulk_import: `${baseUrl}/api/sales-prospect-schools/bulk-import/`,
    sales_prospect_schools_bulk_delete: `${baseUrl}/api/sales-prospect-schools/bulk-delete/`,
    sales_prospect_school_detail: (id) => `${baseUrl}/api/sales-prospect-schools/${id}/`,
    sales_prospect_school_comments: (id) => `${baseUrl}/api/sales-prospect-schools/${id}/comments/`,
    sales_prospect_school_book_demo: (id) => `${baseUrl}/api/sales-prospect-schools/${id}/book-demo/`,
    super_admin_ticket_stats : `${baseUrl}/api/super-admin/ticket-stats/`,
    super_admin_tickets : `${baseUrl}/api/super-admin/tickets/`,
    super_admin_billing : `${baseUrl}/api/super-admin/billing/`,
    super_admin_billing_payment_context : (schoolId, billingMonthIso) =>
        `${baseUrl}/api/super-admin/billing/schools/${schoolId}/payment-context/?billing_month=${encodeURIComponent(billingMonthIso)}`,
    super_admin_billing_school_year_overview : (schoolId, year) =>
        `${baseUrl}/api/super-admin/billing/schools/${schoolId}/year-overview/?year=${encodeURIComponent(year)}`,
    super_admin_billing_school_convert_to_annual : (schoolId) =>
        `${baseUrl}/api/super-admin/billing/schools/${schoolId}/convert-to-annual/`,
    super_admin_billing_school_notify : (schoolId) =>
        `${baseUrl}/api/super-admin/billing/schools/${schoolId}/notify/`,
    super_admin_billing_school_payments : (schoolId) =>
        `${baseUrl}/api/super-admin/billing/schools/${schoolId}/monthly-payments/`,
    super_admin_billing_payment : (paymentId) =>
        `${baseUrl}/api/super-admin/billing/monthly-payments/${paymentId}/`,
    super_admin_billing_payment_invoice : (paymentId) =>
        `${baseUrl}/api/super-admin/billing/monthly-payments/${paymentId}/invoice/`,
    super_admin_billing_gateway_transactions: `${baseUrl}/api/super-admin/billing/gateway-transactions/`,
    super_admin_billing_recorded_payments: `${baseUrl}/api/super-admin/billing/recorded-payments/`,
    super_admin_hr_salary_components: `${baseUrl}/api/super-admin/hr-payroll/salary-components/`,
    super_admin_hr_salary_components_seed: `${baseUrl}/api/super-admin/hr-payroll/salary-components/seed-defaults/`,
    super_admin_hr_payroll_staff: `${baseUrl}/api/super-admin/hr-payroll/staff/`,
    super_admin_hr_salary_structures: `${baseUrl}/api/super-admin/hr-payroll/salary-structures/`,
    super_admin_hr_payroll_deductions: `${baseUrl}/api/super-admin/hr-payroll/deductions/`,
    super_admin_hr_payroll_salary_assignments: `${baseUrl}/api/super-admin/hr-payroll/salary-assignments/`,
    super_admin_hr_payroll_salary_details: `${baseUrl}/api/super-admin/hr-payroll/salary-details/`,
    super_admin_hr_payroll_runs: `${baseUrl}/api/super-admin/hr-payroll/runs/`,
    super_admin_hr_my_payslips: `${baseUrl}/api/super-admin/hr-payroll/my-payslips/`,
    update_onboard_school_detail: `${baseUrl}/api/schools/`,
    delete_onboard_school_detail: `${baseUrl}/api/delete/schools/`,

    // Content Hub (Super Admin) — Blogs & News Articles
    super_admin_blogs: `${baseUrl}/api/super-admin/blogs/`,
    super_admin_blog_detail: (id) => `${baseUrl}/api/super-admin/blogs/${id}/`,
    super_admin_blogs_analytics: `${baseUrl}/api/super-admin/blogs/analytics/`,
    super_admin_news_articles: `${baseUrl}/api/super-admin/news-articles/`,
    super_admin_news_article_detail: (id) => `${baseUrl}/api/super-admin/news-articles/${id}/`,
    super_admin_news_articles_analytics: `${baseUrl}/api/super-admin/news-articles/analytics/`,

    //  CLASSES & SECTIONS RELATED URLS
    add_classes_to_school : `${baseUrl}/api/classes/`,
    view_all_classes_of_your_school : `${baseUrl}/api/view-all-classes-by-school-id/`,
    add_sections_to_class : `${baseUrl}/api/sections/` ,
    view_all_section_of_one_class : `${baseUrl}/api/view-all-sections-of-one-class/`,
    view_classes_and_sections_basedOn_school_id: `${baseUrl}/api/all-sections-by-school-id/`,
    filter_students : `${baseUrl}/api/fetch-myschool-students/`,
    fetch_all_class_and_sections: `${baseUrl}/api/view-all-classes-by-school-id/`,
    edit_classes: `${baseUrl}/api/view-all-classes/`,
    update_sections: `${baseUrl}/api/edit-sections/`,
    delete_sections: `${baseUrl}/api/delete-sections/`,
    filter_sections_by_class: `${baseUrl}/api/filter-sections/`,

    // SUBJECTS RELATED URLS
    add_subjects_to_schools : `${baseUrl}/api/subjects/create/`,
    view_subjects_of_schools : `${baseUrl}/api/subjects/view/`,
    school_study_material: `${baseUrl}/api/school/study-material/`,
    my_todos: `${baseUrl}/api/my-todos/`,
    /** PATCH/DELETE append `<uuid>/` */
    my_todos_detail: `${baseUrl}/api/my-todos/`,
    school_announcements: `${baseUrl}/api/school/announcements/`,
    school_announcement_detail: `${baseUrl}/api/school/announcements/`,
    my_announcements: `${baseUrl}/api/my-announcements/`,
    update_subjects_of_schools : `${baseUrl}/api/subjects/update/`,
    delete_subject_of_school : `${baseUrl}/api/delete-subject/`,
    
    // Fetching Onboarded schools
    fetch_all_onboarded_schools_by_loggedIn_userId : `${baseUrl}/api/view-onboarded-school-by-user-id/`,
    onboard_school : `${baseUrl}/api/schools/`,
    fetch_all_schools: `${baseUrl}/api/schools/`,

    // FACULTY RELATED API'S
    select_class_and_faculty_to_assign_class_teacher : `${baseUrl}/api/view-teacher-details-to-assign-as-CT/`,
    assign_classs_teacher : `${baseUrl}/api/faculties/`,
    /** DELETE `{delete_faculty}{uuid}/` → `/faculties/<uuid>/` */
    delete_faculty : `${baseUrl}/api/faculties/`,
    show_class_teachers_by_school : `${baseUrl}/api/get-class-teachers-by-school/`,
    view_faculty_by_school_id : `${baseUrl}/api/view-faculty-by-school/`,
    class_timetables: `${baseUrl}/api/school/class-timetables/`,
    faculty_leave_balance : `${baseUrl}/api/faculty-leave-balance/`,
    delete_class_teacher : `${baseUrl}/api/delete-class-teacher/`,

    // FEES RELATED API's
    assign_fees_to_class : `${baseUrl}/api/assign-fees-post/`,
    school_fee_types: `${baseUrl}/api/school/fee-types/`,
    school_fee_assignments_matrix: `${baseUrl}/api/school/fee-assignments/matrix/`,
    school_fee_assignments_bulk: `${baseUrl}/api/school/fee-assignments/bulk/`,
    school_fee_assignments_list: `${baseUrl}/api/school/fee-assignments/`,
    view_fee_details_by_school_id : `${baseUrl}/api/get-fee-details-by-school/`,
    display_fees_while_adding_stundent : `${baseUrl}/api/display-fee/`,
    school_fee_assignments_lookup: `${baseUrl}/api/school/fee-assignments/lookup/`,
    fetch_student_fees_records_by_student_id: `${baseUrl}/api/fees/by-student-id/`,
    collect_fee_record: `${baseUrl}/api/payment/`,
    fetch_by_admission_num: `${baseUrl}/api/fetch-student-by-admission/`,
    school_expenditures: `${baseUrl}/api/school/expenditures/`,
    fees_class_wise: `${baseUrl}/api/fees/class-wise/`,
    fees_verify_receipt: `${baseUrl}/api/fees/verify-receipt/`,
    fees_send_reminder: `${baseUrl}/api/fees/send-reminder/`,
    fees_reminders: `${baseUrl}/api/fees/reminders/`,
    fees_arrears: `${baseUrl}/api/fees/arrears/`,

    // Exam Related API's
    Add_exam_to_school : `${baseUrl}/api/examinations/create/`,
    View_examinations_assigned_to_school : `${baseUrl}/api/examinations/view/`,
    update_exam_details: `${baseUrl}/api/examinations/update/`,
    mark_exam_as_final: `${baseUrl}/api/examinations/`,
    delete_exam_details: `${baseUrl}/api/examinations/delete/`,

    // Calander Events API's
    get_school_events: `${baseUrl}/api/fetch-events/`,
    add_school_event: `${baseUrl}/api/events/add/`,
    update_school_event: `${baseUrl}/api/events/update/`,
    delete_school_event: `${baseUrl}/api/events/delete/`,

    // Academic Year Related API's
    get_academic_year: `${baseUrl}/api/academic-years/`,
    add_academic_year: `${baseUrl}/api/academic-years/create/`,
    update_academic_year: `${baseUrl}/api/academic-years/update/`,
    remove_academic_year: `${baseUrl}/api/academic-years/delete/`,

    // Dashboard Related API's
    fetch_dashboard_data: `${baseUrl}/api/dashboard-statistics/`,
    dashboard_fee_monthly_summary: `${baseUrl}/api/dashboard/fee-monthly-summary/`,
    dashboard_fee_class_collection: `${baseUrl}/api/dashboard/fee-class-collection/`,
    dashboard_fee_type_statistics: `${baseUrl}/api/dashboard/fee-type-statistics/`,
    dashboard_income_expenditure: `${baseUrl}/api/dashboard/income-expenditure/`,
    dashboard_faculty_planning_stats: `${baseUrl}/api/dashboard/faculty-planning-stats/`,
    attendance_dashboard_summary: `${baseUrl}/api/attendance/dashboard/class-summary/`,
    school_attendance_dashboard_summary: `${baseUrl}/api/attendance/dashboard/school-summary/`,

    // Attendance related API's
    create_attendance: `${baseUrl}/api/create-attendance/`,
    faculty_view_attendance: `${baseUrl}/api/view-attendance/`,
    ClassTeacher_update_attendance: `${baseUrl}/api/attendance-record/update/`,
    attendance_summary: `${baseUrl}/api/attendance-summary/`,

    faculty_diary: `${baseUrl}/api/faculty/diary/`,

    school_salary_components: `${baseUrl}/api/school/salary-components/`,
    school_salary_components_seed: `${baseUrl}/api/school/salary-components/seed-defaults/`,
    school_payroll_employees: `${baseUrl}/api/school/payroll-employees/`,
    school_employee_salary_structures: `${baseUrl}/api/school/employee-salary-structures/`,
    school_payroll_runs: `${baseUrl}/api/school/payroll-runs/`,
    school_my_payslips: `${baseUrl}/api/school/my-payslips/`,

    // Complaints (faculty)
    faculty_complaint_context: `${baseUrl}/api/faculty/complaint-context/`,
    faculty_complaints_mine: `${baseUrl}/api/faculty/complaints/mine/`,
    faculty_complaint_student_search: `${baseUrl}/api/faculty/complaint-student-search/`,
    add_complaint: `${baseUrl}/api/add-complaint/`,
    school_admin_tickets: `${baseUrl}/api/school-admin/tickets/`,
    /** GET `?class_id=&section_id=&date=YYYY-MM-DD` — school head/admin, school-scoped diary (subject plans). */
    school_admin_teaching_plans: `${baseUrl}/api/school-admin/teaching-plans/`,
    school_admin_app_billing: (year) =>
        `${baseUrl}/api/school-admin/app-billing/?year=${encodeURIComponent(year)}`,
    school_admin_app_billing_invoice: (paymentId) =>
        `${baseUrl}/api/school-admin/app-billing/monthly-payments/${paymentId}/invoice/`,
    school_admin_app_billing_initiate_payment: `${baseUrl}/api/school-admin/app-billing/initiate-payment/`,
    school_admin_app_billing_payment_status: (merchantOrderId) =>
        `${baseUrl}/api/school-admin/app-billing/payment-status/?merchant_order_id=${encodeURIComponent(merchantOrderId)}`,
    school_admin_app_billing_payment_preview: (billingMonth) =>
        `${baseUrl}/api/school-admin/app-billing/payment-preview/?billing_month=${encodeURIComponent(billingMonth)}`,
    support_lead_tickets: `${baseUrl}/api/thrillion-staff/support-lead/tickets/`,
    school_info_stats: `${baseUrl}/api/school-info/stats/`,
    school_info_tickets: `${baseUrl}/api/school-info/tickets/`,

    // Progress Report related API's
    create_progress_report: `${baseUrl}/api/progress-report/`,
    faculty_markssheet_data: `${baseUrl}/api/faculty/marks-sheet-data/`,
    faculty_action_plans: `${baseUrl}/api/faculty/action-plans/`,
    /** GET/PUT/DELETE append `<uuid>/` → `/faculty/action-plans/<uuid>/` */
    faculty_action_plan_detail: `${baseUrl}/api/faculty/action-plans/`,
    faculty_syllabus_plans: `${baseUrl}/api/faculty/syllabus-plans/`,
    /** GET/PUT/DELETE append `<uuid>/` */
    faculty_syllabus_plan_detail: `${baseUrl}/api/faculty/syllabus-plans/`,
    /** POST append `<subtopicId>/comments/` */
    faculty_syllabus_subtopic_comments: `${baseUrl}/api/faculty/syllabus-subtopics/`,
    school_admin_syllabus_plans: `${baseUrl}/api/school-admin/syllabus-plans/`,
    /** GET append `<uuid>/` */
    school_admin_syllabus_plan_detail: `${baseUrl}/api/school-admin/syllabus-plans/`,

    faculty_leave_summary: `${baseUrl}/api/faculty/leave-requests/summary/`,
    faculty_leave_requests: `${baseUrl}/api/faculty/leave-requests/`,
    faculty_leave_request_detail: `${baseUrl}/api/faculty/leave-requests/`,
    school_faculty_leave_requests: `${baseUrl}/api/school/faculty-leave-requests/`,
    /** GET `{school_faculty_leave_summary}{facultyId}/leave-summary/` */
    school_faculty_leave_summary: `${baseUrl}/api/school/faculty/`,
    /** GET `{school_faculty_payroll_summary}{facultyId}/payroll-summary/` */
    school_faculty_payroll_summary: `${baseUrl}/api/school/faculty/`,
    school_faculty_leave_request_decision: `${baseUrl}/api/school/faculty-leave-requests/`,
    school_faculty_tasks: `${baseUrl}/api/school/faculty-tasks/`,
    /** PATCH/DELETE append `<uuid>/` → `/school/faculty-tasks/<uuid>/` */
    school_faculty_task_detail: `${baseUrl}/api/school/faculty-tasks/`,
    school_transport_vehicles: `${baseUrl}/api/school/transport-vehicles/`,
    school_transport_vehicle_maintenance: `${baseUrl}/api/school/transport-vehicle-maintenance/`,
    school_transport_vehicle_maintenance_detail: (logId) =>
        `${baseUrl}/api/school/transport-vehicle-maintenance/${logId}/`,
    school_transport_routes: `${baseUrl}/api/school/transport-routes/`,
    school_transport_route_detail: (routeId) =>
        `${baseUrl}/api/school/transport-routes/${routeId}/`,
    school_transport_seat_layout: `${baseUrl}/api/school/transport-seat-layout/`,
    school_transport_seat_assignments: `${baseUrl}/api/school/transport-seat-assignments/`,
    school_transport_seat_assignment_detail: (assignmentId) =>
        `${baseUrl}/api/school/transport-seat-assignments/${assignmentId}/`,
    school_transport_assignable_students: `${baseUrl}/api/school/transport-assignable-students/`,

    faculty_notifications: `${baseUrl}/api/faculty/notifications/`,
    faculty_notifications_unread_count: `${baseUrl}/api/faculty/notifications/unread-count/`,
    faculty_my_assigned_tasks: `${baseUrl}/api/faculty/my-assigned-tasks/`,
    /** GET/PATCH append `<uuid>/` */
    faculty_my_assigned_task_detail: `${baseUrl}/api/faculty/my-assigned-tasks/`,

    school_leave_policy: `${baseUrl}/api/school/leave-policy/`,
    school_leave_policy_sync: `${baseUrl}/api/school/leave-policy/sync/`,
    assign_sub_to_exam: `${baseUrl}/api/assign-subject-to-exam/`,
    view_exam_sub_config: `${baseUrl}/api/view-exam-subject-conf/`,
    exam_subject_mark_components: `${baseUrl}/api/exam-subject-mark-components/`,
    exam_subject_grade_bands: `${baseUrl}/api/exam-subject-grade-bands/`,
    exam_total_grade_bands: `${baseUrl}/api/exam-total-grade-bands/`,
    add_marks_bulk: `${baseUrl}/api/student-marks/bulk-create/`,

    // LuxeHara Accessories Related API's
    add_orders : `${baseUrl}/api/orders/`,
    add_products: `${baseUrl}/api/products/`,
    add_package_prices: `${baseUrl}/api/package-prices/`,

    school_website_me: `${baseUrl}/api/school-website/me/`,
    school_website_image: (slot) => `${baseUrl}/api/school-website/me/images/${slot}/`,
    school_website_carousel: `${baseUrl}/api/school-website/me/carousel/`,
    school_website_section: (num) => `${baseUrl}/api/school-website/me/sections/${num}/`,
    school_website_marquee: `${baseUrl}/api/school-website/me/marquee/`,
    school_website_marquee_item: (id) => `${baseUrl}/api/school-website/me/marquee/items/${id}/`,
    school_website_gallery: `${baseUrl}/api/school-website/me/gallery/`,
    school_website_gallery_detail: (id) => `${baseUrl}/api/school-website/me/gallery/${id}/`,
    school_website_pages: `${baseUrl}/api/school-website/me/pages/`,
    school_admission_enquiries: `${baseUrl}/api/school-admission-enquiries/`,
    school_admission_enquiry_detail: (id) => `${baseUrl}/api/school-admission-enquiries/${id}/`,

    application_testing_buckets: `${baseUrl}/api/application-testing/buckets/`,
    application_testing_purge: `${baseUrl}/api/application-testing/purge/`,
    application_testing_create_case: `${baseUrl}/api/application-testing/cases/`,
    application_testing_case_manage: (caseId) =>
      `${baseUrl}/api/application-testing/cases/${caseId}/`,
    application_testing_bucket_detail: (bucketId) =>
      `${baseUrl}/api/application-testing/buckets/${bucketId}/`,
    application_testing_pass: (caseId) =>
      `${baseUrl}/api/application-testing/cases/${caseId}/pass/`,
    application_testing_bug: (caseId) =>
      `${baseUrl}/api/application-testing/cases/${caseId}/bug/`,
    application_testing_completed: `${baseUrl}/api/application-testing/completed/`,
    application_testing_bugs: `${baseUrl}/api/application-testing/bugs/`,
    application_testing_raise_bug: `${baseUrl}/api/application-testing/bugs/raise/`,
    application_testing_bug_assign: (resultId) =>
      `${baseUrl}/api/application-testing/bugs/${resultId}/assign/`,
    application_testing_bug_retest: (resultId) =>
      `${baseUrl}/api/application-testing/bugs/${resultId}/retest/`,
    application_testing_case_retest: (caseId) =>
      `${baseUrl}/api/application-testing/cases/${caseId}/retest/`,
    application_testing_case_detail: (caseId) =>
      `${baseUrl}/api/application-testing/cases/${caseId}/detail/`,
    application_testing_case_assign: (caseId) =>
      `${baseUrl}/api/application-testing/cases/${caseId}/assign/`,
    application_testing_case_comments: (caseId) =>
      `${baseUrl}/api/application-testing/cases/${caseId}/comments/`,
    application_testing_case_raise_bug: (caseId) =>
      `${baseUrl}/api/application-testing/cases/${caseId}/raise-bug/`,
    application_testing_staff_options: `${baseUrl}/api/application-testing/staff-options/`,
    application_testing_assignments: `${baseUrl}/api/application-testing/assignments/`,
    application_testing_assignment_delete: (assignmentId) =>
      `${baseUrl}/api/application-testing/assignments/${assignmentId}/`,
    school_website_verify_domain: (schoolId) =>
        `${baseUrl}/api/school-website/schools/${schoolId}/verify-domain/`,
};

/** POST — school admin escalates after SLA breach */
export function schoolAdminTicketEscalateUrl(ticketId) {
    return `${baseUrl}/api/school-admin/tickets/${ticketId}/escalate/`;
}

/** PATCH — support lead / super admin assigns ticket */
export function thrillionStaffTicketAssignUrl(ticketId) {
    return `${baseUrl}/api/thrillion-staff/tickets/${ticketId}/assign/`;
}

export function thrillionStaffTicketWorkUrl(ticketId) {
    return `${baseUrl}/api/thrillion-staff/tickets/${ticketId}/`;
}

/** GET/PATCH ticket detail + thread */
export function ticketDetailUrl(ticketId) {
    return `${baseUrl}/api/tickets/${ticketId}/`;
}

/** POST school or staff reply */
export function ticketMessagesUrl(ticketId) {
    return `${baseUrl}/api/tickets/${ticketId}/messages/`;
}